import { render } from "./Value.vue?vue&type=template&id=00c560f0&scoped=true"
import script from "./Value.vue?vue&type=script&lang=js"
export * from "./Value.vue?vue&type=script&lang=js"

import "./Value.vue?vue&type=style&index=0&id=00c560f0&scoped=true&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c560f0"]])

export default __exports__